import React, { Component } from "react";
import $ from "jquery";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import { SnackbarProvider, withSnackbar } from "notistack";
import {
  Checkbox,
  CircularProgress,
  Button,
  DialogContent,
  DialogContentText,
  FormControlLabel,
} from "@material-ui/core";
import { Button as Buttonn, Text } from "@nextui-org/react";
import AES128 from "./AES128";
import Data from "./Data";
import Dialog from "@material-ui/core/Dialog";
import "date-fns";
import falocale from "moment/locale/fa";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Autocomplete, Box } from "@mui/material";
import Print from "./Print";
import { Modal } from "@nextui-org/react";
import Receipt from "./Receipt";

jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

class Pay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classid: "",
      jalase: 4,
      jaerror: false,
      code_meli: "",
      fathername: "",
      homephone: "",
      borncity: "",
      borndate: "",
      birthday: "",
      mizantahsilat: "",
      job: "",
      moaref: "",
      address: "",
      classs: {},
      price: "",
      phone: "",
      info: "",
      tax: 0,
      taxactive: "off",
      taxprice: "",
      codeoff: "",
      offcode: "",
      off: 0,
      offtext: "",
      name: "",
      open: false,
      open2: false,
      options: [],
      pherror: false,
      nerror: false,
      cmerror: false,
      fnerror: false,
      hperror: false,
      bcerror: false,
      bderror: false,
      mterror: false,
      jerror: false,
      merror: false,
      aerror: false,
      calenderopen: false,
      today: false,
      openReceiptModal: false,
      createdate: "",
      lastdate: "",
      hash: "",
    };
  }

  componentDidMount() {
    let t = localStorage.getItem("admintoken");
    let d = new FormData();
    d.append("token", t);
    if (t !== null) {
      axios
        .post(Data.server + `getToken.php`, d)
        .then((response) => {
          if (response.data.auth === "yes") {
          }
          if (response.data.auth === "no") {
            window.location.href = "/login";
            localStorage.removeItem("admintoken");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      var qp = new URLSearchParams(window.location.search);
      window.location.href = "/login";
    }

    document.title = "تکمیل اطلاعات - پنل مدیریت آموزشگاه شمشال";
    this.setState({
      open: false,
    });

    var qp = new URLSearchParams(window.location.search);
    $("#loading").removeClass("novisible");
    $("#invalid_token").addClass("novisible");
    $("#pay").addClass("novisible");
    $("#progressTop").addClass("novisible");

    if (
      qp.get("token") !== "" &&
      qp.get("token") !== null &&
      qp.get("token") !== undefined
    ) {
      let token = AES128.decrypt(AES128.keyy, AES128.ivv, qp.get("token"));
      if (token !== "" && token !== null && token !== undefined) {
        let studentphone = sessionStorage.getItem("phone");
        let data = new FormData();
        data.append("phone", studentphone);
        data.append("id", token);
        axios
          .post(Data.server + `getPayInfo.php`, data)
          .then((response) => {
            console.log(response.data);
            if (response.data.hasOwnProperty("data")) {
              const { data, price, info, phone, name, tax, taxactive } =
                response.data;
              $("#pay").removeClass("novisible");

              if (info != null) {
                this.setState({
                  fathername: info["fathername"],
                  homephone: info["homephone"],
                  code_meli: info["nationalcode"],
                  borncity: info["borncity"],
                  birthday: info["birthday"],
                  borndate: jMoment(info["birthday"], "jYYYY-jMM-jDD"),
                  mizantahsilat: info["mizantahsilat"],
                  moaref: info["moaref"],
                  job: info["job"],
                  address: info["address"],
                });
              }
              this.setState({
                classid: token,
                classs: data[0],
                price: price,
                phone: phone,
                tax: parseInt(tax),
                taxactive: taxactive,
                name: name,
              });
            }
            if (response.data.hasOwnProperty("no_item")) {
              $("#invalid_token").removeClass("novisible");
              $("#pay").addClass("novisible");
            }
            $("#loading").addClass("novisible");
          })
          .catch((error) => {
            console.log(error);
            $("#select_instrument").removeClass("novisible");
            $("#loading").addClass("novisible");
          });
      } else {
        $("#loading").addClass("novisible");
        $("#invalid_token").removeClass("novisible");
        $("#pay").addClass("novisible");
      }
    } else {
      $("#loading").addClass("novisible");
      $("#invalid_token").removeClass("novisible");
      $("#pay").addClass("novisible");
    }
  }

  handleChange(event) {
    let fields = this.state;
    let target = event.target;
    fields[target.name] = target.value;
    this.setState(fields);
    if (target.name === "name") {
      this.setState({
        nerror: false,
      });
    }
    if (target.name === "code_meli") {
      this.setState({
        cmerror: false,
      });
    }
    if (target.name === "fathername") {
      this.setState({
        fnerror: false,
      });
    }
    if (target.name === "homephone") {
      this.setState({
        hperror: false,
      });
    }
    if (target.name === "borncity") {
      this.setState({
        bcerror: false,
      });
    }
    if (target.name === "mizantahsilat") {
      this.setState({
        mterror: false,
      });
    }
    if (target.name === "job") {
      this.setState({
        jerror: false,
      });
    }
    if (target.name === "job") {
      this.setState({
        jerror: false,
      });
    }
    if (target.name === "moaref") {
      this.setState({
        merror: false,
      });
    }
    if (target.name === "address") {
      this.setState({
        aerror: false,
      });
    }
  }
  handlePhoneChange(event) {}
  handlePhoneChange2(o, v) {
    let fields = this.state;
    fields["phone"] = v;
    fields["name"] = "";
    fields["code_meli"] = "";
    fields["fathername"] = "";
    fields["homephone"] = "";
    fields["borncity"] = "";
    fields["borndate"] = "";
    fields["birthday"] = "";
    fields["mizantahsilat"] = "";
    fields["job"] = "";
    fields["moaref"] = "";
    fields["address"] = "";
    fields["options"] = [];
    fields["pherror"] = false;

    if (v.length === 11) {
      $("#progressTop").removeClass("invisible");
      $("#progressTop").removeClass("novisible");
      $("#waitspinner").modal("show");

      fields["open2"] = false;
      var qp = new URLSearchParams(window.location.search);
      let token = AES128.decrypt(AES128.keyy, AES128.ivv, qp.get("token"));
      sessionStorage.setItem("phone", v);
      let data = new FormData();
      data.append("phone", v);
      data.append("id", token);

      axios
        .post(Data.server + `getPayInfo.php`, data)
        .then((response) => {
          $("#progressTop").addClass("invisible");
          $("#waitspinner").modal("hide");
          if (response.data.hasOwnProperty("data")) {
            const { data, price, info, phone, name, tax, taxactive } =
              response.data;

            if (info != null) {
              this.setState({
                fathername: info["fathername"],
                homephone: info["homephone"],
                code_meli: info["nationalcode"],
                borncity: info["borncity"],
                birthday: info["birthday"],
                borndate: jMoment(info["birthday"], "jYYYY-jMM-jDD"),
                mizantahsilat: info["mizantahsilat"],
                moaref: info["moaref"],
                job: info["job"],
                address: info["address"],
              });
            }
            this.setState({
              classid: token,
              classs: data[0],
              price: price,
              phone: phone,
              tax: parseInt(tax),
              taxactive: taxactive,
              name: name,
            });
          }
          if (response.data.hasOwnProperty("no_item")) {
            $("#invalid_token").removeClass("novisible");
            $("#pay").addClass("novisible");
          }
        })
        .catch((error) => {
          console.log(error);
          $("#progressTop").addClass("invisible");
          $("#waitspinner").modal("hide");
        });
    } else {
      let t = localStorage.getItem("admintoken");
      let data = new FormData();
      data.append("search", v);
      data.append("token", t);
      axios
        .post(Data.server + `searchPhone.php`, data)
        .then((response) => {
          if (response.data.hasOwnProperty("data")) {
            const data0 = response.data.data;
            console.log(data0);
            console.log(response.data);
            this.setState({
              options: data0,
              open2: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    this.setState(fields);
  }

  handleChange2(event) {
    let fields = this.state;
    let target = event.target;
    fields[target.name] = target.checked;
    this.setState(fields);
  }
  handleDateChange(date) {
    this.setState({
      bderror: !moment(date).isValid(),
      borndate: moment(date).isValid() ? date : "",
      birthday: moment(date).isValid()
        ? date.locale("en").format("jYYYY-jMM-jDD")
        : "",
    });

    let date2 = moment(date).isValid() ? date.locale("fa") : "";
  }

  handleOff(code) {
    this.setState({
      open: true,
    });

    let token = localStorage.getItem("token");
    let data = new FormData();
    data.append("token", token);
    data.append("code", code);
    data.append("phone", this.state.phone);
    axios
      .post(Data.mainserver + `checkOffCode.php`, data)
      .then((response) => {
        this.setState({
          open: false,
        });
        if (response.data.hasOwnProperty("data")) {
          const { code, percent, description } = response.data.data;

          this.setState({
            codeoff: "",
            offcode: code,
            off: percent,
            offtext: description,
          });
          this.props.enqueueSnackbar("کد تخفیف با موفقیت اعمال شد", {
            variant: "success",
          });
        }
        if (response.data === "old code") {
          this.props.enqueueSnackbar("این کد تخفیف منقضی شده است", {
            variant: "warning",
          });
        }
        if (response.data === "private code") {
          this.props.enqueueSnackbar("این کد برای شما قابل استفاده نیست", {
            variant: "warning",
          });
        }
        if (response.data === "wrong code") {
          this.props.enqueueSnackbar("کد تخفیف اشتباه است", {
            variant: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        $("#select_instrument").removeClass("novisible");
        $("#loading").addClass("novisible");
      });
  }

  handlePay(taxprice, endprice) {
    const {
      jalase,
      code_meli,
      fathername,
      homephone,
      borncity,
      birthday,
      mizantahsilat,
      job,
      moaref,
      address,
      classs,
      classid,
      price,
      tax,
      taxactive,
      phone,
      name,
      off,
      codeoff,
      offcode,
      offtext,
      today,
      openReceiptModal,
    } = this.state;
    if (phone != null && phone.length === 11) {
      if (name != null && name.length >= 3) {
        if (code_meli != null && code_meli.length === 10) {
          if (fathername !== "") {
            if (homephone !== "") {
              if (borncity !== "") {
                if (birthday !== "") {
                  if (mizantahsilat !== "") {
                    if (job !== "") {
                      if (moaref !== "") {
                        if (address !== "") {
                          let day = classs["day"];
                          let dayid = classs["dayid"];
                          let time = classs["time"];
                          let timee = time.split("-");
                          let starttime = timee[0];
                          let endtime = timee[1];
                          let masterid = classs["masterid"];
                          let mastername = classs["mastername"];
                          let masterpic = classs["masterpic"];
                          let instrumentid = classs["instrumentid"];
                          let instrumentname = classs["instrumentname"];
                          let instrumentpic = classs["instrumentpic"];
                          let jalasegift = jalase;
                          if (jalase === 12) {
                            jalasegift = jalase + 1;
                          }
                          if (jalase === 24) {
                            jalasegift = jalase + 2;
                          }
                          if (jalase === 48) {
                            jalasegift = jalase + 4;
                          }

                          let tttt = today ? "this" : "next";
                          let token = localStorage.getItem("token");
                          let data = new FormData();
                          data.append("token", token);
                          data.append("jalase", jalasegift);
                          data.append("name", name);
                          data.append("phone", phone);
                          data.append("nationalcode", code_meli);
                          data.append("fathername", fathername);
                          data.append("homephone", homephone);
                          data.append("borncity", borncity);
                          data.append("birthday", birthday);
                          data.append("mizantahsilat", mizantahsilat);
                          data.append("job", job);
                          data.append("moaref", moaref);
                          data.append("address", address);
                          data.append("off", off);
                          data.append("offcode", offcode);
                          data.append("offtext", offtext);
                          data.append("tax", tax);
                          data.append("taxactive", taxactive);
                          data.append("taxprice", taxprice);
                          data.append("price", price);
                          data.append("endprice", endprice);
                          data.append("classid", classid);
                          data.append("day", day);
                          data.append("dayid", dayid);
                          data.append("starttime", starttime);
                          data.append("endtime", endtime);
                          data.append("masterid", masterid);
                          data.append("mastername", mastername);
                          data.append("masterpic", masterpic);
                          data.append("instrumentid", instrumentid);
                          data.append("instrumentname", instrumentname);
                          data.append("instrumentpic", instrumentpic);
                          data.append("today", tttt);
                          this.setState({
                            open: true,
                          });

                          axios
                            .post(Data.server + `setOrder.php`, data)
                            .then((response) => {
                              this.setState({
                                open: false,
                              });
                              console.log(response.data);
                              if (response.data.hasOwnProperty("success")) {
                                this.props.enqueueSnackbar(
                                  "ثبت نام با موفقیت انجام شد",
                                  {
                                    variant: "success",
                                  }
                                );
                                const { success } = response.data;

                                this.setState(
                                  {
                                    hash: success["hash"],
                                    createdate: success["createdate"],
                                    lastdate: success["lastdate"],
                                  },
                                  () => {
                                    this.setState({
                                      openReceiptModal: true,
                                    });
                                  }
                                );
                              } else {
                                if (response.data === "error_val") {
                                  this.props.enqueueSnackbar(
                                    "خطا در ارسال داده ها , لطفا صفحه را رفرش کنید",
                                    {
                                      variant: "warning",
                                    }
                                  );
                                }
                                if (response.data.includes("insert error")) {
                                  this.props.enqueueSnackbar(
                                    "خطا در ثبت اطلاعات",
                                    {
                                      variant: "warning",
                                    }
                                  );
                                }
                                if (response.data.includes("update error")) {
                                  this.props.enqueueSnackbar(
                                    "خطا در بروزرسانی اطلاعات",
                                    {
                                      variant: "warning",
                                    }
                                  );
                                }
                              }
                            })
                            .catch((error) => {
                              console.log(error);
                              $("#select_instrument").removeClass("novisible");
                              $("#loading").addClass("novisible");
                            });
                        } else {
                          this.setState({
                            aerror: true,
                          });
                          this.props.enqueueSnackbar("لطفا آدرس را وارد کنید", {
                            variant: "warning",
                          });
                        }
                      } else {
                        this.setState({
                          merror: true,
                        });
                        this.props.enqueueSnackbar(
                          "لطفا طریقه آشنایی با ما را مشخص کنید",
                          {
                            variant: "warning",
                          }
                        );
                      }
                    } else {
                      this.setState({
                        jerror: true,
                      });
                      this.props.enqueueSnackbar(
                        "لطفا شغل خود را انتخاب کنید",
                        {
                          variant: "warning",
                        }
                      );
                    }
                  } else {
                    this.setState({
                      mterror: true,
                    });
                    this.props.enqueueSnackbar(
                      "لطفا میزان تحصیلات خود را انتخاب کنید",
                      {
                        variant: "warning",
                      }
                    );
                  }
                } else {
                  this.setState({
                    bderror: true,
                  });
                  this.props.enqueueSnackbar(
                    "لطفا تاریخ تولد خود را وارد کنید",
                    {
                      variant: "warning",
                    }
                  );
                }
              } else {
                this.setState({
                  bcerror: true,
                });
                this.props.enqueueSnackbar("لطفا محل صدور را وارد کنید", {
                  variant: "warning",
                });
              }
            } else {
              this.setState({
                hperror: true,
              });
              this.props.enqueueSnackbar("لطفا تلفن ثابت را وارد کنید", {
                variant: "warning",
              });
            }
          } else {
            this.setState({
              fnerror: true,
            });
            this.props.enqueueSnackbar("لطفا نام پدر را وارد کنید", {
              variant: "warning",
            });
          }
        } else {
          this.setState({
            cmerror: true,
          });
          this.props.enqueueSnackbar("لطفا کدملی 10 رقمی را کامل وارد کنید", {
            variant: "warning",
          });
        }
      } else {
        this.setState({
          nerror: true,
        });
        this.props.enqueueSnackbar("لطفا نام نام خانوادگی را وارد کنید", {
          variant: "warning",
        });
      }
    } else {
      this.setState({
        pherror: true,
      });
      this.props.enqueueSnackbar("لطفا شماره همراه را کامل وارد کنید", {
        variant: "warning",
      });
    }
  }
  componentRef = null;

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  handleClose() {
    this.setState({
      open: false,
    });
  }

  handleClose2() {
    window.location.href = "/addstudent";
  }

  render() {
    const {
      jalase,
      jaerror,
      code_meli,
      fathername,
      homephone,
      borncity,
      borndate,
      mizantahsilat,
      job,
      moaref,
      address,
      classs,
      price,
      tax,
      taxactive,
      phone,
      name,
      off,
      codeoff,
      offcode,
      offtext,
      open,
      open2,
      options,
      pherror,
      nerror,
      cmerror,
      fnerror,
      hperror,
      bcerror,
      bderror,
      mterror,
      jerror,
      merror,
      aerror,
      today,
      openReceiptModal,
      createdate,
      lastdate,
      hash,
    } = this.state;
    const loading =
      phone != null &&
      options.length === 0 &&
      phone != null &&
      phone.length != 11;
    let taxprice = <div />;
    let offprice = <div />;

    let endprice = parseInt(price) * jalase;

    let taxp = 0;
    if (tax !== 0 && taxactive === "on") {
      taxp = parseInt((endprice * tax) / 100);

      endprice = endprice + taxp;
      taxprice = (
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <div>
            <h6 className="my-0">{tax + "% درصد مالیات"}</h6>
            <small className="text-muted">مالیات ارزش افزوده</small>
          </div>
          <span className="text-muted">
            {AES128.formatMoney(taxp) + " تومان"}
          </span>
        </li>
      );
    }

    if (off !== 0 && offcode !== "" && offtext !== "" && jalase >= 4) {
      let offp = parseInt((endprice * off) / 100);
      endprice = endprice - offp;
      offprice = (
        <li className="nov list-group-item d-flex justify-content-between align-items-center bg-light">
          <div className="text-danger">
            <h6 className="my-0">{off + "% تخفیف"}</h6>
            <small className="text-danger">
              {offtext} <br />
              {"(" + offcode + ")"}
            </small>
          </div>
          <span className="text-danger">
            {AES128.formatMoney(offp) + " تومان"}
          </span>
        </li>
      );
    } else {
      if (parseInt(price) >= 170000) {
        // if (jalase >= 4 && jalase <= 11) {
        //   endprice -= 20000;
        //   offprice = (
        //     <li className="nov list-group-item d-flex justify-content-between align-items-center bg-light">
        //       <div className="text-danger">
        //         <h6 className="my-0">{"تخفیف ویژه"}</h6>
        //         <small className="text-danger">
        //           {"تخفیف ویژه دوره یک ماهه"}
        //         </small>
        //       </div>
        //       <span className="text-danger">
        //         {AES128.formatMoney(20000) + " تومان"}
        //       </span>
        //     </li>
        //   );
        // }
        if (jalase === 12) {
          endprice -= price;
          offprice = (
            <li className="nov list-group-item d-flex justify-content-between align-items-center bg-light">
              <div className="text-danger">
                <h6 className="my-0">{"تخفیف ویژه"}</h6>
                <small className="text-danger">
                  {"تخفیف ویژه دوره سه ماهه"}
                </small>
              </div>
              <span className="text-danger">
                {AES128.formatMoney(price) + " تومان"}
              </span>
            </li>
          );
        }
        if (jalase === 24) {
          endprice -= price * 2;
          offprice = (
            <li className="nov list-group-item d-flex justify-content-between align-items-center bg-light">
              <div className="text-danger">
                <h6 className="my-0">{"تخفیف ویژه"}</h6>
                <small className="text-danger">
                  {"تخفیف ویژه دوره شش ماهه"}
                </small>
              </div>
              <span className="text-danger">
                {AES128.formatMoney(price * 2) + " تومان"}
              </span>
            </li>
          );
        }
        if (jalase === 48) {
          endprice -= price * 3;
          offprice = (
            <li className="nov list-group-item d-flex justify-content-between align-items-center bg-light">
              <div className="text-danger">
                <h6 className="my-0">{"تخفیف ویژه"}</h6>
                <small className="text-danger">
                  {"تخفیف ویژه دوره یک ساله"}
                </small>
              </div>
              <span className="text-danger">
                {AES128.formatMoney(price * 3) + " تومان"}
              </span>
            </li>
          );
        }
      }
    }

    return (
      <div>
        <div data-spy="scroll" data-target="navbar">
          <Modal
            blur
            closeButton
            preventClose
            aria-labelledby="modal-title"
            open={openReceiptModal}
            onClose={this.handleClose2.bind(this)}
          >
            <Modal.Header>
              <Text id="modal-title" size={18}>
                ثبت نام موفق
              </Text>
            </Modal.Header>

            <Modal.Footer>
              <Print
                name={name}
                phone={phone}
                code_meli={code_meli}
                mastername={classs["mastername"]}
                classname={classs["instrumentname"]}
                time={classs["time"]}
                jalase={jalase}
                createdate={createdate}
                lastdate={lastdate}
                price={parseInt(price) * parseInt(jalase)}
                offtext={offcode != "" ? offtext + " (" + offcode + ")" : ""}
                offprice={
                  parseInt(price) * parseInt(jalase) - parseInt(endprice)
                }
                endprice={endprice}
                hash={hash}
              />
              <Buttonn
                auto
                color="error"
                type="submit"
                onPress={this.handleClose2.bind(this)}
              >
                بستن
              </Buttonn>
            </Modal.Footer>
          </Modal>
          <div
            className="section novisible animate__animated animate__zoomInUp animate__slow"
            id="pay"
          >
            <div className="container text-center">
              <div className="row">
                <div className="col-md-8 order-1 order-md-0 mt-4 mt-md-0">
                  <h4 className="text-right">اطلاعات کلاس</h4>
                  <div className="row">
                    <div className="col-12 col-lg-6 mt-lg-0 mt-3">
                      <div className="card features radius bg-info">
                        <div className="card-body">
                          <div className="media">
                            <span className="ti-alarm-clock ti-3x text-white ml-3"></span>
                            <div className="media-body">
                              <h4 className="caef-title text-white">
                                {classs["day"] + " ها"}
                              </h4>
                              <p className="card-text text-white">
                                ساعت کلاس
                                <br />
                                {classs["time"]}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 mt-lg-0 mt-3">
                      <div className="card features radius bg-success">
                        <div className="card-body">
                          <div className="media">
                            <img
                              className="circle-icon ml-3"
                              style={{ height: "3rem", width: "3rem" }}
                              src={
                                classs["masterpic"] === ""
                                  ? Data.server + "icons/user.png"
                                  : Data.server +
                                    "images/" +
                                    classs["masterpic"]
                              }
                            />
                            <div className="media-body">
                              <h4 className="caef-title text-white">
                                {"استاد " + classs["mastername"]}
                              </h4>
                              <p className="card-text text-white mb-0">
                                {"کلاس " + classs["instrumentname"]}{" "}
                                <img
                                  height="20px"
                                  width="20px"
                                  src={
                                    Data.server +
                                    "icons/" +
                                    classs["instrumentpic"]
                                  }
                                />
                              </p>
                              <a
                                className="card-text"
                                href={"/masters/" + classs["masterid"]}
                                target="_blank"
                              >
                                مشاهده مشخصات
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h4 className="text-right mt-4">اطلاعات هنرجو</h4>

                  <div className="row">
                    <div className="col-12 col-lg-6 mt-lg-0 mt-3">
                      <div className="card features radius bg-secondary">
                        <div className="card-body">
                          <div className="media">
                            <span className="ti-user ti-3x ml-3 text-white" />
                            <div className="media-body">
                              <h4 className="caef-title text-white">{name}</h4>
                              <p className="card-text text-white">
                                {"شماره تلفن : " + phone}
                              </p>
                              <a
                                className="btn btn-outline-light"
                                target="_blank"
                                href="/account"
                              >
                                ویرایش
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="needs-validation">
                    <div className="row form-group">
                      <div className="col-md-6 align-self-center">
                        <Autocomplete
                          id="asynchronous-demo"
                          sx={{ width: "100%" }}
                          freeSolo
                          open={open2}
                          onOpen={() => {
                            this.setState({ open2: true });
                          }}
                          onClose={() => {
                            this.setState({ open2: false });
                          }}
                          name="phone"
                          inputValue={phone}
                          onInputChange={(e, newInputValue) =>
                            this.handlePhoneChange2(e, newInputValue)
                          }
                          options={options}
                          getOptionLabel={(option) => option.phone}
                          renderOption={(props, option) => (
                            <Box component="li" {...props}>
                              {option.title}
                            </Box>
                          )}
                          loading={loading}
                          loadingText="در حال بارگذازی ..."
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="شماره همراه"
                              helperText="لطفا شماره همراه خود را وارد کنید"
                              margin="normal"
                              error={pherror}
                              variant="outlined"
                              type="number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value
                                  .toString()
                                  .slice(0, 11);
                                e.target.value = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {loading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                                inputMode: "numeric",
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-md-6">
                        <TextField
                          id="name"
                          className="w-100"
                          name="name"
                          value={name}
                          type="name"
                          onChange={this.handleChange.bind(this)}
                          label="نام نام خانوادگی"
                          helperText="لطفا نام نام خانوادگی خود را وارد کنید"
                          margin="normal"
                          error={nerror}
                          variant="outlined"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextField
                          id="code_meli"
                          className="w-100"
                          name="code_meli"
                          value={code_meli}
                          type="number"
                          inputProps={{ inputMode: "numeric" }}
                          onChange={this.handleChange.bind(this)}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 10);
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          label="کد ملی"
                          helperText="لطفا کد ملی خود را وارد کنید"
                          margin="normal"
                          error={cmerror}
                          variant="outlined"
                        />
                      </div>

                      <div className="col-md-6">
                        <TextField
                          id="fathername"
                          className="w-100"
                          name="fathername"
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 20);
                          }}
                          value={fathername}
                          type="fathername"
                          onChange={this.handleChange.bind(this)}
                          label="نام پدر"
                          error={fnerror}
                          helperText="لطفا نام پدر خود را وارد کنید"
                          margin="normal"
                          variant="outlined"
                        />
                      </div>

                      <div className="col-md-6">
                        <TextField
                          id="homephone"
                          className="w-100"
                          name="homephone"
                          inputProps={{ inputMode: "numeric" }}
                          value={homephone}
                          type="homephone"
                          onChange={this.handleChange.bind(this)}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 11);
                            e.target.value = e.target.value.replace(/\D/g, "");
                          }}
                          label="تلفن ثابت"
                          helperText="لطفا تلفن ثابت را با پیش شماره وارد کنید"
                          margin="normal"
                          error={hperror}
                          variant="outlined"
                        />
                      </div>
                      <div className="col-md-6">
                        <TextField
                          id="borncity"
                          className="w-100"
                          name="borncity"
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .toString()
                              .slice(0, 24);
                          }}
                          value={borncity}
                          type="borncity"
                          onChange={this.handleChange.bind(this)}
                          label="محل صدور"
                          error={bcerror}
                          helperText="لطفا محل صدور خود را وارد کنید"
                          margin="normal"
                          variant="outlined"
                        />
                      </div>
                      <div className="col-md-6">
                        <MuiPickersUtilsProvider
                          utils={JalaliUtils}
                          locale={falocale}
                        >
                          <KeyboardDatePicker
                            id="borndate"
                            className="w-100"
                            name="borndate"
                            inputProps={{
                              readOnly: true,
                            }}
                            variant="dialog"
                            minDate="1922-01-01"
                            maxDate={moment().format("YYYY-MM-DD")}
                            labelFunc={(date) =>
                              moment(date).isValid()
                                ? date.format("jD jMMMM jYYYY")
                                : ""
                            }
                            okLabel={"تایید"}
                            cancelLabel={"لغو"}
                            open={this.state.calenderopen}
                            inputVariant="outlined"
                            value={borndate}
                            type="borndate"
                            onClick={() =>
                              this.setState({ calenderopen: true })
                            }
                            onClose={() =>
                              this.setState({ calenderopen: false })
                            }
                            onChange={(date) => this.handleDateChange(date)}
                            label="تاریخ تولد"
                            error={bderror}
                            helperText="لطفا تاریخ تولد خود را وارد کنید"
                            margin="normal"
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div className="col-md-6">
                        <FormControl
                          variant="outlined"
                          className="w-100"
                          margin="normal"
                        >
                          <InputLabel id="mizantahsilatl">
                            میزان تحصیلات
                          </InputLabel>
                          <Select
                            labelId="mizantahsilatl"
                            id="mizantahsilat"
                            name="mizantahsilat"
                            value={mizantahsilat}
                            error={mterror}
                            onChange={this.handleChange.bind(this)}
                            label="میزان تحصیلات"
                          >
                            <MenuItem value="زیر دیپلم">زیر دیپلم</MenuItem>
                            <MenuItem value="دیپلم">دیپلم</MenuItem>
                            <MenuItem value="فوق دیپلم">فوق دیپلم</MenuItem>
                            <MenuItem value="لیسانس">لیسانس</MenuItem>
                            <MenuItem value="فوق لیسانس">فوق لیسانس</MenuItem>
                            <MenuItem value="دکترا">دکترا</MenuItem>
                          </Select>
                          <FormHelperText>
                            لطفا میزان تحصیلات خود را انتخاب کنید
                          </FormHelperText>
                        </FormControl>
                      </div>
                      <div className="col-md-6">
                        <FormControl
                          variant="outlined"
                          className="w-100"
                          margin="normal"
                        >
                          <InputLabel id="jobl">شغل</InputLabel>
                          <Select
                            labelId="jobl"
                            id="job"
                            name="job"
                            value={job}
                            error={jerror}
                            onChange={this.handleChange.bind(this)}
                            label="شغل"
                          >
                            <MenuItem value="بیکار">بیکار</MenuItem>
                            <MenuItem value="دانش آموز">دانش آموز</MenuItem>
                            <MenuItem value="دانشجو">دانشجو</MenuItem>
                            <MenuItem value="خانه دار">خانه دار</MenuItem>
                            <MenuItem value="شغل آزاد">شغل آزاد</MenuItem>
                            <MenuItem value="فروشنده">فروشنده</MenuItem>
                            <MenuItem value="بازاریاب">بازاریاب</MenuItem>
                            <MenuItem value="معلم">معلم</MenuItem>
                            <MenuItem value="کارمند">کارمند</MenuItem>
                            <MenuItem value="برنامه نویس">برنامه نویس</MenuItem>
                            <MenuItem value="گرافیست">گرافیست</MenuItem>
                            <MenuItem value="پزشک">پزشک</MenuItem>
                            <MenuItem value="مهندس">مهندس</MenuItem>
                          </Select>
                          <FormHelperText>
                            لطفا شغل خود را انتخاب کنید
                          </FormHelperText>
                        </FormControl>
                      </div>
                      <div className="col-md-6">
                        <FormControl
                          variant="outlined"
                          className="w-100"
                          margin="normal"
                        >
                          <InputLabel id="moarefl">معرف</InputLabel>
                          <Select
                            labelId="moarefl"
                            id="moaref"
                            name="moaref"
                            value={moaref}
                            error={merror}
                            onChange={this.handleChange.bind(this)}
                            label="معرف"
                          >
                            <MenuItem value="اینترنت">
                              جست و جو در اینترنت
                            </MenuItem>
                            <MenuItem value="دوستان">دوستان و آشنایان</MenuItem>
                            <MenuItem value="تبلیغات">تبلیغات</MenuItem>
                            <MenuItem value="شبکه های اجتماعی">
                              شبکه های اجتماعی
                            </MenuItem>
                          </Select>
                          <FormHelperText>
                            از چه طریقی با ما آشنا شدید ؟
                          </FormHelperText>
                        </FormControl>
                      </div>
                      {/*<div className="col-12">*/}
                      {/*    <TextField*/}
                      {/*        id="moarefphone"*/}
                      {/*        className="w-100"*/}
                      {/*        name="moarefphone"*/}
                      {/*        value={moarefphone}*/}
                      {/*        type="moarefphone"*/}
                      {/*        onChange={this.handleChange.bind(this)}*/}
                      {/*        onInput={(e) => {*/}
                      {/*            e.target.value = e.target.value.toString().slice(0, 11)*/}
                      {/*            e.target.value = e.target.value.replace(/\D/g, "")*/}
                      {/*        }}*/}
                      {/*        label="شماره موبایل معرف (اختیاری)"*/}
                      {/*        helperText="لطفا اگر شخصی آموزشگاه را به شما معرفی کرده شماره موبایلش را وارد کنید"*/}
                      {/*        margin="normal"*/}
                      {/*        variant="outlined"/>*/}
                      {/*</div>*/}
                    </div>

                    <TextField
                      id="address"
                      className="w-100"
                      name="address"
                      value={address}
                      type="address"
                      onChange={this.handleChange.bind(this)}
                      label="آدرس"
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .toString()
                          .slice(0, 300);
                      }}
                      margin="normal"
                      helperText="لطفا آدرس خود را وارد کنید"
                      error={aerror}
                      variant="outlined"
                    />

                    <FormControlLabel
                      value="start"
                      id="today"
                      control={
                        <Checkbox
                          color="primary"
                          name="today"
                          checked={today}
                          onChange={this.handleChange2.bind(this)}
                        />
                      }
                      label={<span>جلسات از امروز محاسبه شود</span>}
                      labelPlacement="end"
                    />

                    <hr className="mb-4" />

                    <button
                      className="btn btn-primary btn-block btn-lg"
                      onClick={() => this.handlePay(taxp, endprice)}
                    >
                      ثبت نام
                    </button>
                  </div>
                </div>

                <div className="col-md-4 order-0 order-md-1">
                  <h4 className="d-flex justify-content-between">
                    <span className="text-muted">هزینه ثبت نام</span>
                    {/*<span className="badge badge-secondary badge-pill">4</span>*/}
                  </h4>
                  <FormControl
                    variant="outlined"
                    className="w-100"
                    margin="normal"
                  >
                    <InputLabel id="jalasel">انتخاب دوره</InputLabel>
                    <Select
                      labelId="jalasel"
                      id="jalase"
                      name="jalase"
                      value={jalase}
                      error={jaerror}
                      onChange={this.handleChange.bind(this)}
                      label="انتخاب دوره"
                    >
                      <MenuItem value={1}>یک جلسه</MenuItem>
                      <MenuItem value={2}>دو جلسه</MenuItem>
                      <MenuItem value={3}>سه جلسه</MenuItem>
                      <MenuItem value={4}>
                        یک ماهه (4 جلسه) (دارای تخفیف)
                      </MenuItem>
                      <MenuItem value={5}>پنج جلسه</MenuItem>
                      <MenuItem value={6}>نیم ترم (6 جلسه)</MenuItem>
                      <MenuItem value={7}>هفت جلسه</MenuItem>
                      <MenuItem value={8}>هشت جلسه</MenuItem>
                      <MenuItem value={9}>نه جلسه</MenuItem>
                      <MenuItem value={10}>ده جلسه</MenuItem>
                      <MenuItem value={11}>یازده جلسه</MenuItem>
                      <MenuItem value={12}>
                        یک ترم (12 جلسه + 1 جلسه هدیه)
                      </MenuItem>
                      <MenuItem value={24}>
                        دو ترم (24 جلسه + 2 جلسه هدیه)
                      </MenuItem>
                      <MenuItem value={48}>
                        چهار ترم (48 جلسه + 4 جلسه هدیه)
                      </MenuItem>
                    </Select>
                    <FormHelperText>
                      لطفا دوره آموزشی مورد نظر خود را انتخاب کنید
                    </FormHelperText>
                  </FormControl>

                  <ul className="list-group mt-3">
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="my-0">{jalase + " جلسه کلاس"}</h6>
                        <small className="text-muted">
                          {"هر جلسه " + AES128.formatMoney(price) + " تومان"}
                        </small>
                      </div>
                      <span className="text-muted">
                        {AES128.formatMoney(price * jalase) + " تومان"}
                      </span>
                    </li>
                    {taxprice}
                    {offprice}
                    <li className="list-group-item d-flex justify-content-between align-items-center">
                      <span>جمع کل</span>
                      <span className="text-muted">
                        {AES128.formatMoney(endprice) + " تومان"}
                      </span>
                    </li>
                  </ul>

                  <div className="card p-2 mt-3">
                    <div className="input-group">
                      <input
                        name="codeoff"
                        value={codeoff}
                        onChange={this.handleChange.bind(this)}
                        type="text"
                        className="form-control"
                        placeholder="کد تخفیف"
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-success"
                          onClick={() => this.handleOff(codeoff)}
                        >
                          اعمال
                        </button>
                        <Dialog
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                          open={open}
                          className="text-right"
                        >
                          <DialogContent>
                            <DialogContentText
                              className="text-center"
                              id="alert-dialog-description"
                            >
                              <div
                                id="loading"
                                className="d-flex mt-3 justify-content-center"
                              >
                                <h4>لطفا کمی صبر کنید ...</h4>
                                <CircularProgress
                                  className="mr-3"
                                  color="secondary"
                                />
                              </div>
                            </DialogContentText>
                          </DialogContent>
                        </Dialog>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section mt-5 novisible" id="invalid_token">
            <div className="container text-center">
              <div className="section-title">
                <h3 className="text-danger">شناسه نامعتبر</h3>
              </div>

              <p>شناسه پرداخت نامعتبر است لطفا مجددا کلاس خود را انتخاب کنید</p>
            </div>
          </div>

          <div
            id="loading"
            className="d-flex mt-3 justify-content-center animate__animated animate__zoomIn"
          >
            <h4>درحال بارگذاری ...</h4>
            <CircularProgress className="mr-3" color="secondary" />
          </div>
        </div>
      </div>
    );
  }
}

const Appppp = withSnackbar(Pay);
const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

function IntegrationNotistack() {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      ref={notistackRef}
      action={(key) => (
        <Button
          color={"#bc2727"}
          onClick={onClickDismiss(key)}
          style={{ fontFamily: "IRANSans" }}
        >
          بستن
        </Button>
      )}
    >
      <Appppp />
    </SnackbarProvider>
  );
}
export default IntegrationNotistack;
